import request from '@/utils/request'

export default {
  /**
   * 获取订单详情
   * @param id
   * @returns {*}
   */
  getById(id) {
    return request.get(`/orders/${id}`)
  },

  /**
   * 提交订单
   * @param data
   */
  submitOrder(data) {
    return request.post('/orders/staff/submit', data)
  },

  /**
   * 提交签送订单
   * @param data
   */
  submitGivingOrder(data) {
    return request.post('/orders/giving/submit', data)
  },

  /**
   * 未支付未出品订单-退品
   * @param data
   */
  returnProduct(data) {
    return request.post('/orders/return/product', data)
  },

  /**
   * 后结出品订单-退换品
   * @param data
   */
  delayOrderRechargeBackOrderProduct(data) {
    return request.post('/orders/delay-order-recharge-back-order-product', data)
  },

  /**
   * 确认收款
   */
  serveConfirmPaid(orderId, data) {
    return request.put(`/orders/${orderId}/serve-confirm-paid`, data)
  },

  /**
   * 签送订单部分退品
   * @param orderId 订单ID
   * @param data { refund_order_items: [{ id: string, refund_count: number }] }
   */
  cancelGivingPartial(orderId, data) {
    return request.put(`/orders/${orderId}/cancel-giving`, data)
  }
}
